import React from 'react';
import PropTypes from 'prop-types';
import createReactClass from 'create-react-class';

import Emojify from 'app/components/shared/Emojify';
import BlockFieldsModal from 'app/components/job/BlockFieldsModal';

/* eslint-disable react/prefer-es6-class */
// TODO: Replace BootstrapTooltipMixin and move to a class

import BootstrapTooltipMixin from 'app/lib/BootstrapTooltipMixin';

export default createReactClass({
  displayName: 'ManualStep',

  mixins: [BootstrapTooltipMixin],

  propTypes: {
    job: PropTypes.shape({
      id: PropTypes.string.isRequired,
      activatePath: PropTypes.string.isRequired,
      fields: PropTypes.array,
      name: PropTypes.string,
      permissions: PropTypes.shape({
        activate: PropTypes.shape({
          allowed: PropTypes.bool.isRequired,
          message: PropTypes.string
        }).isRequired
      }).isRequired,
      prompt: PropTypes.string,
      state: PropTypes.string.isRequired,
      tooltip: PropTypes.string,
      triggerProject: PropTypes.shape({
        name: PropTypes.string.isRequired
      }),
      unblockedAt: PropTypes.string
    }).isRequired,
    stepClassName: PropTypes.string.isRequired
  },

  getInitialState() {
    return { fieldsModalActivated: false };
  },

  componentDidUpdate(prevProps, prevState) {
    if (prevState.fieldsModalActivated !== this.state.fieldsModalActivated) {
      this.fieldsModal.show();
    }
  },

  render() {
    const fieldsModal = this.state.fieldsModalActivated && (
      <BlockFieldsModal
        ref={(fieldsModal) => this.fieldsModal = fieldsModal}
        job={this.props.job}
      />
    );

    return (
      <div
        key={this.props.job.id}
        className="inline-block build-pipeline-job__wrapper"
      >
        {fieldsModal}
        {this.renderStep()}
      </div>
    );
  },

  renderStep() {
    if (this.props.job.state === "broken") {
      return (
        <div
          data-toggle="tooltip"
          title={this.props.job.tooltip}
          className={this.props.stepClassName}
        >
          <span className="build-pipeline-job__icon">
            <i className="fa fa-lock" />
          </span>
          {this.nameNode()}
        </div>
      );
    } else if (!this.props.job.permissions.activate.allowed) {
      return (
        <div
          data-toggle="tooltip"
          title={this.props.job.permissions.activate.message}
          className={this.props.stepClassName}
        >
          <span className="build-pipeline-job__icon">
            <i className="fa fa-lock" />
          </span>
          {this.nameNode()}
        </div>
      );
    } else if (this.props.job.unblockedAt) {
      return (
        <div className={this.props.stepClassName}>
          <span className="build-pipeline-job__icon">
            <i className="fa fa-chevron-right" />
          </span>
          {this.nameNode()}
        </div>
      );
    } else if ((this.props.job.state === "skipped") || (this.props.job.state === "canceled") || (this.props.job.state === "blocked_failed")) {
      return (
        <div className={this.props.stepClassName}>
          <span className="build-pipeline-job__icon">
            <i className="fa fa-lock" />
          </span>
          {this.nameNode()}
        </div>
      );
    }
    if (this.props.job.fields) {
      return (
        <a
          href="#"
          onClick={this.handleContinueButtonClick}
          className={this.props.stepClassName}
        >
          <span className="build-pipeline-job__icon">
            <i className="fa fa-lock" />
          </span>
          {this.nameNode()}
        </a>
      );
    }

    return (
      <a
        href={this.props.job.activatePath}
        data-remote="true"
        data-confirm={this.props.job.prompt || "Unblock this step?"}
        data-method="post"
        className={this.props.stepClassName}
      >
        <span className="build-pipeline-job__icon">
          <i className="fa fa-lock" />
        </span>
        {this.nameNode()}
      </a>
    );
  },

  handleContinueButtonClick(evt) {
    evt.preventDefault();

    if (this.state.fieldsModalActivated) {
      return this.fieldsModal.show();
    }

    this.setState({ fieldsModalActivated: true });
  },

  nameNode() {
    return (
      <span className="build-pipeline-job__name">
        <Emojify text={this.props.job.name || "Continue"} />
      </span>
    );
  }
});
